import { RAIL_WIDTH } from "@/components/sidebar/railConstants";

const AUTH_HAD_SESSION_KEY = "auth-had-session";
// Outlives the session so an expired or reloaded dashboard logs back into the same instance.
const LOGIN_INSTANCE_KEY = "auth-login-instance";

export const APP_RAIL_INSET_CSS_VAR = "--app-rail-inset";

// Pre-paint: a returning session will mount the rail (embeds never do), so the
// server-rendered loader can center past it before any JS runs. Below md the
// rail is hidden on [code]smith routes (useAppRailHiddenOnMobile, isCodesmithPath).
export function appRailInsetBootstrap(): string {
  return `try{var v=localStorage.getItem('${AUTH_HAD_SESSION_KEY}');if((v==='1'||v==='superuser')&&!/[?&]embed=/.test(location.search)&&!(!matchMedia('(min-width: 768px)').matches&&/^(\\/enterprise\\/[^/]+)?(\\/[^/]+)?\\/(sessions|assistant|automations|projects|mcp-connections|codesmith)(\\/|$)/.test(location.pathname)&&!/\\/proof$/.test(location.pathname)))document.documentElement.style.setProperty('${APP_RAIL_INSET_CSS_VAR}','${RAIL_WIDTH}px');}catch(e){}`;
}

export const authHadSession = {
  read(): "1" | "superuser" | false {
    if (typeof window === "undefined") return false;
    try {
      const value = window.localStorage.getItem(AUTH_HAD_SESSION_KEY);
      return value === "1" || value === "superuser" ? value : false;
    } catch {
      return false;
    }
  },
  readLoginInstance(): string | null {
    if (typeof window === "undefined") return null;
    try {
      return window.localStorage.getItem(LOGIN_INSTANCE_KEY);
    } catch {
      return null;
    }
  },
  write(user: {
    is_superuser: boolean;
    login_instance_slug?: string | null;
  }): void {
    try {
      window.localStorage.setItem(
        AUTH_HAD_SESSION_KEY,
        user.is_superuser ? "superuser" : "1",
      );
      // Remember-me and pre-existing sessions report no slug; keep the one from the last real login.
      if (user.login_instance_slug) {
        window.localStorage.setItem(
          LOGIN_INSTANCE_KEY,
          user.login_instance_slug,
        );
      }
    } catch {
      // Storage may be unavailable in restricted browser contexts.
    }
  },
  clear(): void {
    try {
      window.localStorage.removeItem(AUTH_HAD_SESSION_KEY);
    } catch {
      // ignore
    }
  },
};
